import * as React from 'react';
import { Dispatch } from 'redux';
import { EventActionViewModel } from 'stageclip-common';

import { BaseApiGetRequest } from '../generic/baseApiGetRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as EventActionNormalizers from '../normalizers/eventActionNormalizers';

export class GetAllEventActionsRequest extends BaseApiGetRequest<
  EventActionViewModel,
  EntityNormalizers.NormalizedEntityArray<EventActionNormalizers.NormalizedEventActions>
> {
  constructor(eventId: string, component: React.Component, dispatch: Dispatch) {
    super(component, dispatch);
    this.path = `/events/${eventId}/event-actions`;
    this.normalizeMethod = EventActionNormalizers.normalizeEventActionsArray;
  }
}
